//users

export const SET_USER = 'session/SET_USER';
export const REMOVE_USER = 'session/REMOVE_USER';
export const SESSION_LOADED = 'session/SESSION_LOADED';

